// A labelled amount input: unit shown in the field, helper always visible, error right under it and wired for screen readers.
const BBookAmountField = ({ id, label, unit = '€', helper, error, value, onChange, onBlur, disabled, placeholder, step = 'any' }) => {
  const describedBy = [helper && `${id}-helper`, error && `${id}-error`].filter(Boolean).join(' ') || undefined

  return (
    <div className='b_book_field'>
      <label htmlFor={id} className='b_book_field_label'>{label}</label>
      <div className={`b_book_field_control ${error ? 'b_book_field_invalid' : ''}`}>
        <input
          id={id}
          type='number'
          inputMode='decimal'
          min='0'
          step={step}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
        {unit ? <span className='b_book_field_unit' aria-hidden='true'>{unit}</span> : null}
      </div>
      {helper ? <p id={`${id}-helper`} className='b_book_field_helper'>{helper}</p> : null}
      {error ? <p id={`${id}-error`} className='b_book_field_error' role='alert'>{error}</p> : null}
    </div>
  )
}

export default BBookAmountField
